module.exports = __webpack_public_path__ + "img/product-shot_01.ae8e6a45.jpg";